import * as sessionReplay from '@amplitude/session-replay-browser';

if (window.analytics) {
  const registerStatsigMiddleware = () => {
    try {
      if (analytics._statsigMiddlewareRegistered) {
        return;
      }

      if (typeof analytics.addSourceMiddleware !== 'function') {
        analytics._statsigRegisterAttempts = (analytics._statsigRegisterAttempts || 0) + 1;

        if (analytics._statsigRegisterAttempts < 10) {
          setTimeout(registerStatsigMiddleware, 200);
        }

        return;
      }

      analytics.addSourceMiddleware(({ payload, next }) => {
        try {
          if (payload.type() === 'track') {
            const properties = payload.obj.properties || {};

            // Build statsigCustom array with all primitive properties
            // Format: [key1, val1, key2, val2, ...]
            const statsigCustom = Object.entries(properties).reduce((acc, [k, v]) => {
              if (v === null || v === undefined) {
                return acc;
              }

              if (Array.isArray(v) || (typeof v === 'object' && v !== null)) {
                return acc;
              }

              acc.push(String(k), String(v));

              return acc;
            }, []);

            if (statsigCustom.length > 0) {
              payload.obj.properties = {
                ...properties,
                statsigCustom,
              };
            }
          }
        } catch (_err) {
          // Ignore statsig processing errors to avoid breaking the app.
        }

        next(payload);
      });

      analytics._statsigMiddlewareRegistered = true;
    } catch (_err) {
      // Ignore errors registering middleware synchronously
    }
  };

  // Try to register immediately (for early events). Also register again inside
  // `analytics.ready` as a fallback if the analytics client wasn't fully ready.
  registerStatsigMiddleware();

  window.analytics.ready(async () => {
    registerStatsigMiddleware();

    if (window.AMPLITUDE_KEY && window.analytics) {
      const getStoredSessionId = () => {
        const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
          const [key, value] = cookie.split('=');

          acc[key] = value;

          return acc;
        }, {});

        return cookies.analytics_session_id || 0;
      };

      const storedSessionId = getStoredSessionId();

      await sessionReplay.init(AMPLITUDE_KEY, {
        sessionId: storedSessionId,
        deviceId: analytics.user().anonymousId(),
        sampleRate: 0.02,
      }).promise;

      // Add middleware to check if the session id has changed,
      // and update the session replay instance
      analytics.addSourceMiddleware(({ payload, next, integrations }) => {
        const storedSessionId = getStoredSessionId();
        const nextSessionId = payload?.obj?.integrations['Actions Amplitude']?.session_id || 0;

        if (storedSessionId < nextSessionId) {
          document.cookie = `analytics_session_id=${nextSessionId}`;
          sessionReplay.setSessionId(nextSessionId);
        }
        next(payload);
      });

      // Add middleware to always add session replay properties to track calls
      analytics.addSourceMiddleware(({ payload, next, integrations }) => {
        const sessionReplayProperties = sessionReplay.getSessionReplayProperties();

        if (payload.type() === 'track') {
          payload.obj.properties = {
            ...payload.obj.properties,
            ...sessionReplayProperties,
          };
        }

        next(payload);
      });
    }
  });
}
